import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Check if user is authenticated
  const token = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
  
  if (!token) {
    // Redirect to 404 page if not authenticated
    return <Navigate to="/404" replace />;
  }
  
  return children;
};

export default ProtectedRoute;

